class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      // Locked bundle paid line (_bb-item while a free gift is in the cart) cannot be removed
      const cartItem = this.closest('.cart-item');
      if (cartItem && cartItem.dataset.bbLocked === 'true') return;
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    // Prevent decreasing a locked bundle paid line (_bb-item) below its required quantity
    const cartItem = event.target.closest('.cart-item');
    if (cartItem && cartItem.dataset.bbLocked === 'true') {
      const minQty = parseInt(event.target.getAttribute('min'), 10) || 1;
      const newQty = parseInt(event.target.value, 10);
      if (isNaN(newQty) || newQty < minQty) {
        event.target.value = minQty;
        return;
      }
    }

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          // The active header (mega-menu) has no #cart-counter element, so
          // guard against missing targets — otherwise a thrown error here
          // aborts the whole re-render and the drawer never reflects
          // price/quantity/removal changes until a page refresh.
          if (!elementToReplace) return;

          const newInnerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (newInnerHTML == null) return;

          elementToReplace.innerHTML = newInnerHTML;
        });

        // Keep the mega-menu cart count badge in sync (it isn't covered by
        // the #cart-counter target above).
        const counterHTML = parsedState.sections['cart-counter'];
        if (counterHTML) {
          const badge = new DOMParser()
            .parseFromString(counterHTML, 'text/html')
            .querySelector('.cart-count-badge');
          if (badge) {
            const count = (badge.textContent || '').trim();
            document
              .querySelectorAll('.mega-menu__cart-count')
              .forEach(el => (el.textContent = count));
          }
        }

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateFreeShipping();

        document.addEventListener('click', function (event) {
          const header = event.target.closest('.cart-discount-acordian__header');
          if (header) {
            console.log('click');
            header.parentNode.classList.toggle('active');
          }
        });

      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser()
      .parseFromString(html || '', 'text/html')
      .querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
